export * from './google/dynamic/google-dynamic-map.component';
